import APIS from "./APIS"
import Cookies from "universal-cookie"

import { renewSocket } from "../contexts/SocketContext"

const isBrowser = typeof window !== `undefined`

export const setUser = (user) => {
  (window.localStorage.risUpUser = JSON.stringify(user))
}

const getUser = () => {
  if (window.localStorage.risUpUser) {
    let user = JSON.parse(window.localStorage.risUpUser)
    return user ? user : {}
  }
  return {}
}

export const isLoggedIn = () => {
  if (!isBrowser) return false

  const user = getUser()
  if (user && user.id && user.email) {
    return user.id
  } else {
    return false
  }
}

/* ⚠️ LA SESSION SERVEUR FAIT FOI. Jusqu'au 10/09/2026, cette fonction se
 * contentait de supprimer le cookie dans le navigateur : la session restait
 * OUVERTE cote serveur, et le cookie survivait des que le domaine calcule etait
 * faux. THE SCAN avait deja recu la correction, pas THE LAB.
 * Consequence mesurable : apres une deconnexion, `checkLoggedRefresh` de
 * `index.js` interrogeait `/auth/status` avec le cookie survivant, recevait le
 * compte precedent et reconnectait l'utilisateur suivant a sa place — sur un
 * poste partage, en salle de formation, c'est l'identite qui change de mains.
 * On ferme donc la session serveur AVANT le menage local. */
export const logout = callback => {
  if (!isBrowser) return
  // `.catch` AVANT `.then`, et non `.finally` : `finally` execute bien le
  // menage, mais il RELAIE le rejet, ce qui produit une promesse non capturee.
  // Constate par le test du 10/09/2026. L'utilisateur doit etre deconnecte
  // localement meme si le serveur ne repond pas.
  APIS.postLogout().catch(() => null).then(() => { menageLocalPuis(callback) })
}

const menageLocalPuis = callback => {
  const cookies = new Cookies()
  const cookieNames = Object.keys(cookies.getAll())
  cookieNames.forEach((cook) => {
    let searchString = process.env.REACT_APP_COOKIES_SESSION || "pp.connect.sid"
    if (cook.includes(searchString)) {
      let host = document.location.hostname
      let arr = host.split(".")
      if (arr.length === 1) {
        host = arr[0]
      } else {
        arr = arr.slice(-arr.length+1)
        host = "."+arr.join(".")
      }
      cookies.remove(cook, { path: '/', domain : host })
    }
  })
  setUser({})
  /* B37 (25/09/2026, relecture de securite) : la copie du module gardee dans
     l'onglet (reponses et resultats de l'apprenant) ne survit plus a la
     deconnexion, sur un poste partage. */
  try { sessionStorage.removeItem('saveFormation'); sessionStorage.removeItem('saveFormationAdmin') } catch (e) {}
  renewSocket();
  callback()
}


export const getCurrentUser = () => isBrowser && getUser()
